import AboutUs from "../AboutUs";

function GaubertAboutUs() {
  return (
    <AboutUs
      className="GaFa-about"
      titleKey="gaubert.about.title"
      textKey="gaubert.about.text"
    />
  );
}

export default GaubertAboutUs;
